import React, { Children } from "react";
import { SiTradingview } from "react-icons/si";

import GroupsIcon from "@mui/icons-material/Groups";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import RedeemIcon from "@mui/icons-material/Redeem";
import NotesIcon from "@mui/icons-material/Notes";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AppShortcut from "@mui/icons-material/AppShortcut";
import AddToQueue from "@mui/icons-material/AddToQueue";
import CreateNewFolder from "@mui/icons-material/CreateNewFolder";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import GradeIcon from "@mui/icons-material/Grade";
import UploadIcon from "@mui/icons-material/Upload";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import DashboardLayout from "../components/common/DashboardLayout";
import MemoryIcon from "@mui/icons-material/Memory";
import AddAlertIcon from "@mui/icons-material/AddAlert";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import InsightsIcon from "@mui/icons-material/Insights";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import CellTowerIcon from "@mui/icons-material/CellTower";
import WidgetsIcon from "@mui/icons-material/Widgets";
import StyleIcon from "@mui/icons-material/Style";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import LoginIcon from "@mui/icons-material/Login";
import ExtensionIcon from "@mui/icons-material/Extension";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import CampaignIcon from "@mui/icons-material/Campaign";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import PaidIcon from "@mui/icons-material/Paid";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
// const user = JSON.parse(localStorage.getItem("user"));

// IMP: COMMENTED OUT few items AS BACKEND CODE NOT READY, TESTING NOT DONE [17-04-2024]
const mainListItemsArray = [
  {
    id: 12,
    label: "Advisor Performance",
    link: "/admin/advisor-performance",
    icon: <EmojiEventsIcon />,
  },
  {
    id: 13,
    label: "Location History",
    link: "/admin/location-history",
    icon: <LocationOnIcon />,
  },
  {
    id: 14,
    label: "Basket",
    link: "/admin/basket",
    icon: <ShoppingBasketIcon />,
  },
  {
    id: 15,
    label: "TNI Trading",
    link: "/admin/tni-trading",
    icon: <SiTradingview />,
  },
  {
    id: 1,
    label: "Notifications & Engagement",
    icon: <NotificationsActiveIcon />,
    children: [
      {
        id: "1-1",
        label: "Push Notifications",
        link: "/admin/push-notifications",
        icon: <InsightsIcon />,
      },
      {
        id: "1-2",
        label: "One Signals",
        link: "/admin/one-signals",
        icon: <CellTowerIcon />,
      },
      {
        id: "1-2b",
        label: "Conversion Analytics",
        link: "/admin/conversion-analytics",
        icon: <TrendingUpIcon />,
      },
      {
        id: "1-3",
        label: "User Rating",
        link: "/admin/user-rating",
        icon: <GradeIcon />,
      },
      {
        id: "1-4",
        label: "Customer Support",
        link: "/admin/user-support",
        icon: <SupportAgentIcon />,
      },
      {
        id: "1-5",
        label: "Invoice",
        link: "/admin/invoice-dashboard",
        icon: <ReceiptLongIcon />,
      },
      {
        id: "1-6",
        label: "Customer Info",
        link: "/admin/customer-info",
        icon: <SupportAgentIcon />,
      },
      {
        id: "1-7",
        label: "Profit Cards",
        link: "/admin/profit-cards",
        icon: <StyleIcon />,
      },
      {
        id: "1-8",
        label: "Performance Cards",
        link: "/admin/performance-cards",
        icon: <InsightsIcon />,
      },
      {
        id: "1-9",
        label: "Expired Users",
        link: "/admin/expired-users",
        icon: <PersonRemoveIcon />,
        children: [
          {
            id: "1-9-1",
            label: "Expired Dashboard",
            link: "/admin/expired-users",
            icon: <PersonRemoveIcon />,
          },
          {
            id: "1-9-2",
            label: "Plan Extensions",
            link: "/admin/expired-users/plan-extensions",
            icon: <ExtensionIcon />,
          },
          {
            id: "1-9-3",
            label: "Plan Changes",
            link: "/admin/expired-users/plan-changes",
            icon: <SwapHorizIcon />,
          },
        ],
      },
      {
        id: "1-10",
        label: "Login History",
        link: "/admin/login-history",
        icon: <LoginIcon />,
      },
      {
        id: "1-11",
        label: "Trading Activity",
        link: "/admin/trading-activity",
        icon: <InsightsIcon />,
      },
    ],
  },

  {
    id: 2,
    label: "Alerts Managements",
    icon: <ManageHistoryIcon />,
    children: [
      {
        id: "2-1",
        label: "All Alerts",
        link: "/admin/alerts-managements/all-alerts",
        icon: <AddAlertIcon />,
      },
      {
        id: "2-2",
        label: "Alerts-Stockyaari",
        link: "/admin/alerts-managements/alerts-stockyaari",
        icon: <PersonAddIcon />,
      },
      {
        id: "2-3",
        label: "Signals-Dashboard",
        link: "/admin/alerts-managements/signals-dashboard",
        icon: <DatasetLinkedIcon />,
      },
      {
        id: "2-4",
        label: "Alerts",
        link: "/admin/alerts",
        icon: <NotificationsActiveIcon />,
      },
      {
        id: "2-5",
        label: "Stock-Alerts",
        link: "/admin/stock-alerts",
        icon: <AddAlertIcon />,
      },
    ],
  },

  {
    id: 3,
    label: "Ticker Configuration",
    link: "/admin/ticker-configuration",
    icon: <SettingsSuggestIcon />,
    children: [
      {
        id: "3-1",
        label: "Screen Name",
        link: "/admin/ticker-configuration/screen-name",
        icon: <AppShortcut />,
      },
      {
        id: "3-2",
        label: "Create Ticker",
        link: "/admin/ticker-configuration/create-ticker",
        icon: <NotesIcon />,
      },
    ],
  },

  {
    id: 4,
    label: "Options Dashboard",
    icon: <CandlestickChartIcon />,
    children: [
      {
        id: "4-1",
        label: "Dashboard Home",
        link: "/admin/options-dashboard",
        icon: <CandlestickChartIcon />,
      },
      {
        id: "4-2",
        label: "Option Disclaimer",
        link: "/admin/options-dashboard/disclaimer",
        icon: <NotesIcon />,
      },
      {
        id: "4-3",
        label: "Option Recommendations",
        link: "/admin/options-dashboard/recommendations",
        icon: <CandlestickChartIcon />,
      },
      {
        id: "4-4",
        label: "Futures Recommendations",
        link: "/admin/options-dashboard/future-recommendations",
        icon: <CandlestickChartIcon />,
      },
    ],
  },

  {
    id: 5,
    label: "Subscriptions",
    icon: <RecentActorsIcon />,
    children: [
      {
        id: "5-1",
        label: "Subscription-Commisions",
        link: "/admin/subscription-commisions",
        icon: <GroupsIcon />,
      },
      {
        id: "5-2",
        label: "Subscription-Visit",
        link: "/admin/user-subscription-history",
        icon: <RecentActorsIcon />,
      },
    ],
  },

  {
    id: 6,
    label: "Users",
    link: "/admin/users",
    icon: <GroupsIcon />,
  },

  {
    id: 8,
    label: "News",
    link: "/admin/news",
    icon: <NewspaperIcon />,
  },

  {
    id: 9,
    label: "Marketing Spend Analysis",
    icon: <CampaignIcon />,
    children: [
      {
        id: "9-1",
        label: "Marketing Channel",
        link: "/admin/marketing-spend-analysis/marketing-channel",
        icon: <AccountTreeIcon />,
      },
      {
        id: "9-2",
        label: "Marketing Spend",
        link: "/admin/marketing-spend-analysis/marketing-spend",
        icon: <PaidIcon />,
      },
    ],
  },

  {
    id: 7,
    label: "Misc",
    icon: <WidgetsIcon />,
    children: [
      {
        id: "7-1",
        label: "Intro Screens",
        link: "/admin/intro-screens",
        icon: <SmartphoneIcon />,
      },
      {
        id: "7-2",
        label: "Stock-Split",
        link: "/admin/stock-split",
        icon: <CallSplitIcon />,
      },
      {
        id: "7-3",
        label: "Futures",
        link: "/admin/futures",
        icon: <CandlestickChartIcon />,
      },
    ],
  },
  {
    id: 10,
    label: "Broker Access",
    link: "/admin/broker-access",
    icon: <AccountBalanceIcon />,
  },
  {
    id: 16,
    label: "Broker Connectivity",
    link: "/admin/broker-connectivity",
    icon: <AccountBalanceIcon />,
  },
  {
    id: 11,
    label: "Broker Trade",
    icon: <ShowChartIcon />,
    children: [
      {
        id: "11-1",
        label: "Trade Dashboard",
        link: "/admin/broker-trade/trade-dashboard",
        icon: <AccountBalanceIcon />,
      },
      {
        id: "11-2",
        label: "Trade Dashboard Symbolwise",
        link: "/admin/broker-trade/trade-dashboard-symbolwise",
        icon: <ShowChartIcon />,
      },
      {
        id: "11-4",
        label: "Symbolwise Drilldown",
        link: "/admin/broker-trade/trade-dashboard-symbolwise-drilldown",
        icon: <CandlestickChartIcon />,
      },
      {
        id: "11-3",
        label: "Open Trade",
        link: "/admin/broker-trade/open-trade",
        icon: <ShowChartIcon />,
      },
    ],
  },
];

// IMP: COMMENTED OUT AS BACKEND CODE NOT READY, TESTING NOT DONE
const secondaryListItemsArray = [
  {
    id: 1,
    label: "Plans & Subscriptions",
    icon: <CreateNewFolder />,
    children: [
      {
        id: "1-1",
        label: "Coupons",
        link: "/admin/coupons",
        icon: <RedeemIcon />,
      },
      {
        id: "1-2",
        label: "Create Plan",
        link: "/admin/create-plan",
        icon: <CreateNewFolder />,
      },
      {
        id: "1-3",
        label: "Create TopUp",
        link: "/admin/create-topup",
        icon: <AddToQueue />,
      },
      {
        id: "1-4",
        label: "Payment Link",
        link: "/admin/payment-link",
        icon: <PaidIcon />,
      },
      {
        id: "1-5",
        label: "Create QR",
        link: "/admin/create-qr",
        icon: <QrCode2Icon />,
      },
      {
        id: "1-6",
        label: "Payment Gateway Configuration",
        link: "/admin/payment-gateway-configuration",
        icon: <SettingsSuggestIcon />,
      },
    ],
  },

  {
    id: 2,
    label: "Payments & Refunds",
    icon: <ReceiptIcon />,
    children: [
      {
        id: "2-1",
        label: "Payments",
        link: "/admin/payments-dashboard",
        icon: <ReceiptIcon />,
      },
      {
        id: "2-2",
        label: "Refund Dashboard",
        link: "/admin/user-refunds",
        icon: <CurrencyExchangeIcon />,
      },
      {
        id: "2-3",
        label: "Failed Payments",
        link: "/admin/failed-payments",
        icon: <CurrencyExchangeIcon />,
      },
      {
        id: "2-4",
        label: "Refund Module Access",
        link: "/admin/refund-module-access",
        icon: <AdminPanelSettingsIcon />,
      },
      {
        id: "2-5",
        label: "Autopay Records",
        link: "/admin/autopay-records",
        icon: <AutorenewIcon />,
      },
    ],
  },

  {
    id: 14,
    label: "Home Page Module Config",
    icon: <WidgetsIcon />,
    children: [
      {
        id: "14-1",
        label: "Main Module Config",
        link: "/admin/home-module-config/main-module",
        icon: <RoomPreferencesIcon />,
      },
      {
        id: "14-2",
        label: "Sub Module Config",
        link: "/admin/home-module-config/sub-module",
        icon: <ExtensionIcon />,
      },
        {
        id: "14-3",
        label: "Main-Sub Mapping",
        link: "/admin/home-module-config/main-sub-mapping",
        icon: <SwapHorizIcon />,
      },
      {
        id: "14-4",
        label: "Module Mapping",
        link: "/admin/home-module-config/module-mapping",
        icon: <AccountTreeIcon />,
      },
    
    ],
  },

  {
    id: 3,
    label: "Home Screen Configuration",
    icon: <SettingsSuggestIcon />,
    children: [
      {
        id: "3-1",
        label: "App Home Screen",
        link: "/admin/home-screen-configuration/home-screen-content",
        icon: <AppShortcut />,
      },
      {
        id: "3-2",
        label: "Upload Banners",
        link: "/admin/home-screen-configuration/upload-banners",
        icon: <UploadIcon />,
      },
      {
        id: "3-3",
        label: "App Configuration",
        link: "/admin/home-screen-configuration/app-configuration",
        icon: <MemoryIcon />,
      },
    ],
  },

  {
    id: 4,
    label: "influencer Management",
    icon: <SettingsSuggestIcon />,
    children: [
      {
        id: "4-1",
        label: "User Referral",
        link: "/admin/influencer-Management/user-referral",
        icon: <RoomPreferencesIcon />,
      },
      {
        id: "4-2",
        label: "Withdrawal",
        link: "/admin/influencer-Management/withdrawal",
        icon: <UploadIcon />,
      },
    ],
  },
];

export default function AdminDashboardLayout() {
  return (
    <DashboardLayout
      mainListItems={mainListItemsArray}
      secondListItems={secondaryListItemsArray}
    />
  );
}
